var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6447_13110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9502 6.84997C19.6702 6.46997 19.3702 6.10997 19.0902 5.84997L19.0002 5.74997C17.6302 4.37997 15.8402 3.44997 13.9502 3.12997C12.0602 2.80997 10.1502 3.06997 8.41017 3.86997C6.64017 4.68997 5.13017 6.08997 4.18017 7.80997C3.26017 9.45997 2.86017 11.4 3.04017 13.27C3.23017 15.18 4.02017 17.03 5.26017 18.49C5.36017 18.6 5.46017 18.7 5.57017 18.8L5.70017 18.92C5.74017 18.98 5.79017 19.02 5.80017 19.02C7.03017 20.24 8.53017 21.08 10.1302 21.47C10.8602 21.65 11.6102 21.74 12.3602 21.74C13.4902 21.74 14.6102 21.54 15.6602 21.15C17.5002 20.46 19.1102 19.18 20.1902 17.54C21.2302 15.97 21.7802 14.06 21.7402 12.16C21.7002 10.25 21.0602 8.35997 19.9402 6.83997L19.9502 6.84997ZM11.5802 20.54C9.92017 20.38 8.31017 19.7 7.05017 18.61C7.03017 18.6 7.02017 18.58 7.00017 18.57L18.5702 7.00997C19.5702 8.15997 20.2302 9.54997 20.4702 11.03C20.7402 12.65 20.5102 14.35 19.8202 15.83C19.0902 17.39 17.8602 18.71 16.3602 19.55C14.9302 20.35 13.2302 20.7 11.5802 20.54ZM4.70017 9.46997C5.30017 7.86997 6.42017 6.46997 7.86017 5.51997C9.19017 4.63997 10.7902 4.16997 12.3902 4.16997C12.4502 4.16997 12.5102 4.16997 12.5702 4.16997C14.2302 4.20997 15.8802 4.76997 17.2202 5.74997C17.4002 5.88997 17.5802 6.02997 17.7402 6.17997L6.19017 17.73C5.32017 16.73 4.71017 15.56 4.40017 14.33C4.01017 12.74 4.11017 11.01 4.69017 9.45997L4.70017 9.46997Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6447_13110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.75,
    height: 18.74,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/blockIcon.e90eac1cd042965bc323f6ac32701da0.svg";
export { ForwardRef as ReactComponent };